// Lightweight availability shared by the path and the preparation registry.
export const ABSOLUTE_VALUE_CODE = "1.1.2";
export const ROOT_OPERATIONS_CODE = "1.1.5";
export const PERCENTAGES_CODE = "1.2.4";
export const POWERS_CODE = "1.4.3";
export const LOGARITHMS_CODE = "1.5.2";
export const SPECIAL_PRODUCTS_CODE = "2.1.2";
export const RATIONAL_EXPRESSIONS_EQUATIONS_CODE = "2.2.3";
export const QUADRATIC_INEQUALITIES_CODE = "2.3.2";
export const LINEAR_INEQUALITIES_CODE = "2.3.1";
export const POLYNOMIAL_OPERATIONS_CODE = "2.7.2";
export const POLYNOMIAL_EQUATIONS_CODE = "2.2.5";
export const LINEAR_SYSTEMS_WORD_PROBLEMS_CODE = "2.4.2";
export const FUNCTION_GRAPH_CODE = "3.1.2";
export const LINEAR_FUNCTION_CODE = "3.2.1";
export const QUADRATIC_CANONICAL_CODE = "3.3.2";
export const QUADRATIC_FACTORED_CODE = "3.3.3";
export const QUADRATIC_OPTIMIZATION_CODE = "3.3.6";
export const SEQUENCE_BASICS_CODE = "4.1.1";
export const ARITHMETIC_SEQUENCE_CODE = "4.2.1";
export const GEOMETRIC_SEQUENCE_CODE = "4.3.1";
export const MIXED_SEQUENCES_CODE = "4.3.5";
export const ACUTE_ANGLE_TRIG_CODE = "5.1.2";
export const TRIG_IDENTITIES_CODE = "5.2.3";
export const TRIANGLE_RADII_CODE = "6.1.3";
export const TRIANGLE_SIMILARITY_CODE = "6.1.7";
export const TRIANGLE_AREA_COSINE_CODE = "6.1.9";
export const CIRCLE_ANGLES_CODE = "6.3.2";
export const SIMILARITY_SCALE_CODE = "6.5.3";
export const ANALYTIC_GEOMETRY_APPLICATIONS_CODE = "7.1.2";
export const LINES_POSITION_CODE = "7.2.3";
export const CIRCLE_EQUATION_CODE = "7.3.1";
export const PRISMS_PYRAMIDS_CODE = "8.1.3";
export const CYLINDER_CONE_CODE = "8.3.1";
export const COMBINATORICS_CODE = "9.1.1";
export const PROBABILITY_BASICS_CODE = "9.2.1";
export const DESCRIPTIVE_STATISTICS_CODE = "9.3.2";
export const DIVISIBILITY_PROOFS_CODE = "10.1.1";

const preparationCodes = new Set([
  ABSOLUTE_VALUE_CODE,
  ROOT_OPERATIONS_CODE,
  PERCENTAGES_CODE,
  POWERS_CODE,
  LOGARITHMS_CODE,
  SPECIAL_PRODUCTS_CODE,
  RATIONAL_EXPRESSIONS_EQUATIONS_CODE,
  QUADRATIC_INEQUALITIES_CODE,
  LINEAR_INEQUALITIES_CODE,
  POLYNOMIAL_EQUATIONS_CODE,
  POLYNOMIAL_OPERATIONS_CODE,
  LINEAR_SYSTEMS_WORD_PROBLEMS_CODE,
  FUNCTION_GRAPH_CODE,
  LINEAR_FUNCTION_CODE,
  QUADRATIC_CANONICAL_CODE,
  QUADRATIC_FACTORED_CODE,
  QUADRATIC_OPTIMIZATION_CODE,
  SEQUENCE_BASICS_CODE,
  ARITHMETIC_SEQUENCE_CODE,
  GEOMETRIC_SEQUENCE_CODE,
  MIXED_SEQUENCES_CODE,
  ACUTE_ANGLE_TRIG_CODE,
  TRIG_IDENTITIES_CODE,
  TRIANGLE_RADII_CODE,
  TRIANGLE_SIMILARITY_CODE,
  TRIANGLE_AREA_COSINE_CODE,
  CIRCLE_ANGLES_CODE,
  SIMILARITY_SCALE_CODE,
  ANALYTIC_GEOMETRY_APPLICATIONS_CODE,
  LINES_POSITION_CODE,
  CIRCLE_EQUATION_CODE,
  PRISMS_PYRAMIDS_CODE,
  CYLINDER_CONE_CODE,
  COMBINATORICS_CODE,
  PROBABILITY_BASICS_CODE,
  DESCRIPTIVE_STATISTICS_CODE,
  DIVISIBILITY_PROOFS_CODE,
]);

export function hasMaturaCoursePreparation(code) {
  return preparationCodes.has(String(code || ""));
}
